import { useRef, useState, useEffect, Ref } from 'preact/hooks';
import { RefObject } from 'preact';
import { isClient } from '../../utils';
import { getClientType } from './common';

const initialState = { width: 0, height: 0, clientType: undefined };
export const useDimension = (): [
  dimensions: { width: number; height: number; clientType?: string },
  ref: Ref<HTMLDivElement>
] => {
  const [dimensions, setDimensions] = useState(initialState);
  const ref: RefObject<HTMLDivElement> = useRef(undefined);
  const resizeObserverRef: RefObject<ResizeObserver> = useRef(undefined);

  useEffect(() => {
    if (isClient()) {
      if ('ResizeObserver' in window) {
        resizeObserverRef.current = new ResizeObserver((entries = []) => {
          entries.forEach((entry) => {
            const { width, height } = entry.contentRect;
            setDimensions({ width, height, clientType: getClientType(width) });
          });
        });

        if (ref.current) {
          resizeObserverRef.current.observe(ref.current);
        }

        return () => {
          if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
          }
        };
      } else if (ref?.current) {
        // check dimension only once if we can't use ResizeObserver
        setTimeout(() => {
          setDimensions({
            width: ref.current.offsetWidth,
            height: ref.current.offsetHeight,
            clientType: getClientType(ref.current.offsetWidth),
          });
        }, 0);
      }
    }
  }, [ref]);

  return [dimensions, ref];
};
